/**
 * Coverax Footer – CSS-Vars aus JSON, Mobile-Akkordeon, Cookie-Settings.
 */
(function () {
  'use strict';

  function applyFooterVars() {
    const varsNode = document.querySelector('[data-coverax-footer-vars]');
    const wrap = document.querySelector('[data-coverax-footer-wrap]');
    if (!varsNode || !wrap) return;

    try {
      const vars = JSON.parse(varsNode.textContent || '{}');
      Object.keys(vars).forEach((key) => {
        const value = vars[key];
        if (value === null || value === undefined || value === '') return;
        wrap.style.setProperty(key, String(value));
      });
    } catch (e) {}
  }

  function syncFooterAccordions() {
    const mq = window.matchMedia('(max-width: 768px)');
    const footer = document.querySelector('.coverax-footer');

    if (!footer || footer.classList.contains('coverax-footer--no-accordion')) {
      document.querySelectorAll('details.footer__accordion').forEach((el) => {
        el.setAttribute('open', '');
      });
      return;
    }

    document.querySelectorAll('details.footer__accordion[data-footer-collapse-mobile]').forEach((el) => {
      if (mq.matches) {
        el.removeAttribute('open');
      } else {
        el.setAttribute('open', '');
      }
    });
  }

  function bindFooterAccordions() {
    const mq = window.matchMedia('(max-width: 768px)');
    syncFooterAccordions();
    if (mq.addEventListener) {
      mq.addEventListener('change', syncFooterAccordions);
    } else if (mq.addListener) {
      mq.addListener(syncFooterAccordions);
    }
  }

  function openCookieSettings(event) {
    event.preventDefault();
    if (typeof window.showPreferences === 'function') {
      window.showPreferences(event.currentTarget);
      return;
    }
    if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
      window.privacyBanner.showPreferences();
      return;
    }
    if (
      window.Shopify &&
      window.Shopify.customerPrivacy &&
      typeof window.Shopify.customerPrivacy.showPreferences === 'function'
    ) {
      window.Shopify.customerPrivacy.showPreferences();
    }
  }

  function bindCookieSettings() {
    document.querySelectorAll('[data-cookie-settings]').forEach((el) => {
      el.addEventListener('click', openCookieSettings);
    });
  }

  function bindBackToTop() {
    document.querySelectorAll('[data-coverax-back-to-top]').forEach((el) => {
      el.addEventListener('click', () => {
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
      });
    });
  }

  applyFooterVars();
  bindFooterAccordions();
  bindCookieSettings();
  bindBackToTop();
})();
